// extracted by mini-css-extract-plugin
module.exports = {"popupMenu":"PopupMenu_popupMenu__1ZI5Z"};